module.exports = __webpack_public_path__ + "static/mandala-324fc43b77ca9eba52f1553bbc8776c4.png";